import { Component, OnInit, OnChanges, Output, EventEmitter, Input } from '@angular/core';

export interface ServerError {
  exception: string;
  place: string;
  message: string;
}

@Component({
  selector: 'cc-http-error',
  templateUrl: './http-error.component.html',
  styleUrls: ['./http-error.component.scss'],
})
export class HttpErrorComponent implements OnInit, OnChanges {

  @Output() retry = new EventEmitter<any>();
  @Input() errorMsg: string = '';
  @Input() serverError?: ServerError;

  constructor() { }

  ngOnInit() { }

  ngOnChanges() { }

}
